// utils/downloadFile.ts

/**
 * Utility to download a file from a base64 string.
 * @param base64String The base64 string representing the file.
 * @param fileName The name of the file to be downloaded (including extension).
 * @param mimeType The MIME type of the file (optional). Default is 'application/octet-stream'.
 */
export const downloadBase64 = (base64String, fileName, mimeType = 'application/octet-stream') => {
  try {
    // Decode the base64 string
    const byteCharacters = atob(base64String)
    const byteNumbers = new Array(byteCharacters.length)

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    const blob = new Blob([byteArray], { type: mimeType })

    // Create a download link and trigger the download
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = fileName
    document.body.appendChild(link) // Required for Firefox
    link.click()
    document.body.removeChild(link) // Cleanup the link element after download
  } catch (error) {
    console.error('Error downloading file: ', error)
  }
}
